export const convertStringArrayToITuple4 = (string) => {
    return string.split(",").map((i) => (parseInt(i.replace('[', '').replace(']', ''))));
};
